<template>
  <div class="spa" :style="{ '--base-color': $theme.basecolor, '--base-dark': $theme.basedark, '--base-light': $theme.baselight }">
    <!-- -------------------------------------------- E R R O R E -------------------------------------------- -->
    <div v-if="errore" class="spa-card shadow spa-messaggio">
      <fa :icon="['fas', 'exclamation-triangle']" class="spa-icona-grande" />
      <div>{{ t(errore) }}</div>
    </div>

    <!-- -------------------------------------------- G R A Z I E -------------------------------------------- -->
    <div v-else-if="fatta" class="spa-card shadow spa-messaggio">
      <fa :icon="['fas', fatta.stato === 'P' ? 'hourglass-half' : 'check-circle']" class="spa-icona-grande" />
      <h2>{{ fatta.stato === "P" ? t("SPA_GrazieAttesa") : t("SPA_Grazie") }}</h2>
      <div class="spa-riepilogo">
        <div><span>{{ t("SPA_Data") }}</span><b>{{ dataLunga(fatta.data) }}</b></div>
        <div><span>{{ t("SPA_Trattamento") }}</span><b>{{ fatta.trattamento }}</b></div>
        <div><span>{{ t("SPA_Orario") }}</span><b>{{ fatta.orario }}</b></div>
        <div><span>{{ t("SPA_Durata") }}</span><b>{{ fatta.durata }}'</b></div>
      </div>
      <p v-if="emailInviata">{{ t("SPA_EmailInviata") }}</p>
      <div class="spa-btn" @click="ricomincia">{{ t("SPA_Nuova") }}</div>
    </div>

    <template v-else-if="pronta">
      <!-- -------------------------------------------- Q U A N D O -------------------------------------------- -->
      <div class="spa-card shadow">
        <h2 class="spa-titolo"><fa :icon="['fas', 'spa']" /> {{ t("SPA_Titolo") }}</h2>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-if="nota" class="spa-nota" v-html="nota" />
        <div class="spa-riga">
          <!-- Non e' una <label>: il clic su una label arriva anche alla
               casella, e al calendario appena aperto sembrerebbe un clic fuori. -->
          <div class="spa-campo spa-campo-data">
            <span>{{ t("SPA_Data") }}</span>
            <!-- Niente casella nativa: scriverebbe la data nel formato del
                 browser (aaaa-mm-gg, mm/gg/aaaa...). Qui si scrive e si legge
                 solo gg/mm/aaaa, con le barre messe mentre si digita, e
                 l'icona apre il calendario del Booking. -->
            <span class="spa-data">
              <input
                :value="dataTesto"
                type="text"
                inputmode="numeric"
                maxlength="10"
                :placeholder="t('SPIA_FormatoData')"
                @input="mascheraData"
                @blur="confermaData()"
                @keyup.enter="confermaData()"
              />
              <cyb-date-picker :value="dataITA(data)" :lang="$store.lang" :disabled-dates="limitiData" @input="(val) => confermaData(val)" />
            </span>
          </div>
          <label v-if="categorie.length > 1" class="spa-campo">
            <span>{{ t("SPA_Categoria") }}</span>
            <select v-model="idcategoria">
              <option :value="0">{{ t("SPA_Categorie") }}</option>
              <option v-for="c in categorie" :key="c.id" :value="c.id">{{ c.nome }}</option>
            </select>
          </label>
          <label v-if="operatori.length" class="spa-campo" :class="{ 'spa-err': errori.idoperatore }">
            <span>{{ t("SPA_Operatore") }}</span>
            <select v-model="idoperatore" @change="caricaDisponibilita">
              <option :value="0">{{ t("SPA_OperatoreNessuno") }}</option>
              <option v-for="o in operatori" :key="o.id" :value="o.id">{{ o.descrizione }}</option>
            </select>
          </label>
        </div>
        <div v-if="operatori.length && idoperatore" class="spa-sub">{{ t("SPA_OperatoreNota") }}</div>
      </div>

      <!-- -------------------------------------------- C A T A L O G O -------------------------------------------- -->
      <div v-if="caricamento" class="spa-card shadow spa-attesa"><fa :icon="['fas', 'spinner']" spin /></div>
      <div v-else-if="chiuso" class="spa-card shadow spa-messaggio">
        <fa :icon="['fas', 'calendar-times']" class="spa-icona-grande" />
        <div>{{ t("SPA_Chiuso") }}</div>
      </div>
      <template v-else>
        <div v-for="c in categorieMostrate" :key="c.id" class="spa-card shadow">
          <h3 class="spa-categoria">{{ c.nome }}</h3>
          <div v-for="tr in c.trattamenti" :key="tr.id" class="spa-tratt" :class="{ scelto: scelta.id === tr.id }">
            <!-- La fotografia e' il modo in cui un trattamento si presenta: chi
                 sceglie un massaggio guarda l'immagine prima del testo. Chi non
                 l'ha caricata tiene comunque il suo posto, con un riquadro
                 sfocato: le schede del catalogo restano tutte della stessa
                 forma, invece di alternarsi larghe e strette. -->
            <img v-if="tr.immagine" class="spa-foto" :src="url(tr.immagine)" :alt="tr.nome" />
            <div v-else class="spa-foto spa-foto-finta" aria-hidden="true"><fa :icon="['fas', 'spa']" /></div>
            <div class="spa-tratt-testo">
              <div class="spa-tratt-nome">{{ tr.nome }}</div>
              <div class="spa-tratt-dati">
                <span><fa :icon="['far', 'clock']" /> {{ tr.durata }}'</span>
                <span v-if="tr.prezzo > 0"><fa :icon="['fas', 'euro-sign']" /> {{ prezzo(tr.prezzo) }}</span>
                <span v-if="tr.persone > 1"><fa :icon="['fas', 'user-friends']" /> {{ tr.persone }}</span>
              </div>
              <div v-if="tr.descrizione" class="spa-tratt-desc">{{ tr.descrizione }}</div>
              <div v-if="orari(tr.id).length" class="spa-orari">
                <div class="spa-sub">{{ t("SPA_Scegli") }}</div>
                <div class="spa-orari-elenco">
                  <div
                    v-for="o in orari(tr.id)"
                    :key="tr.id + o"
                    class="spa-orario"
                    :class="{ scelto: scelta.id === tr.id && scelta.orario === o }"
                    @click="scegli(tr, o)"
                  >
                    {{ o }}
                  </div>
                </div>
              </div>
              <div v-else class="spa-sub">
                {{ t("SPA_NonDisp") }}. {{ t("SPA_NonDispNota") }}<span v-if="telefono"> {{ telefono }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- -------------------------------------------- C H I -------------------------------------------- -->
      <div v-if="scelta.orario" ref="dati" class="spa-card shadow">
        <h2 class="spa-titolo"><fa :icon="['fas', 'user']" /> {{ t("SPA_Dati") }}</h2>
        <div class="spa-scelta">
          {{ iniziale(dataLunga(data)) }} · {{ scelta.nome }} · {{ scelta.orario }} · {{ scelta.durata }}'
        </div>
        <div class="spa-riga">
          <label class="spa-campo largo" :class="{ 'spa-err': errori.nome }">
            <span>{{ t("SPA_Nome") }} *</span>
            <input v-model.trim="form.nome" type="text" maxlength="100" autocomplete="name" />
          </label>
          <label class="spa-campo" :class="{ 'spa-err': errori.telefono }">
            <span>{{ t("Tel") }} *</span>
            <input v-model.trim="form.telefono" type="tel" maxlength="30" autocomplete="tel" />
          </label>
          <label class="spa-campo" :class="{ 'spa-err': errori.email }">
            <span>{{ t("Email2") }} *</span>
            <input v-model.trim="form.email" type="email" maxlength="150" autocomplete="email" />
          </label>
        </div>
        <label class="spa-campo largo">
          <span>{{ t("SPA_Note") }}</span>
          <textarea v-model="form.note" rows="2" maxlength="255" />
        </label>
        <!-- Campo civetta: invisibile alle persone, i programmi lo riempiono. -->
        <input v-model="form.sito" type="text" name="sito" class="spa-civetta" tabindex="-1" autocomplete="off" />
        <!-- Le condizioni del trattamento scelto: sono le policy delle tariffe,
             le stesse che il cliente legge prenotando una camera. -->
        <div v-if="scelta.policy" class="spa-policy">
          <div class="spa-sub"><b>{{ t("SPA_Policy") }}</b></div>
          <div class="spa-policy-testo">{{ scelta.policy }}</div>
        </div>
        <div v-if="privacy" class="spa-policy">
          <div class="spa-sub"><b>{{ t("Privacy") }}</b></div>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="spa-policy-testo" v-html="privacy" />
        </div>
        <label class="spa-accetto" :class="{ 'spa-err': errori.privacy }">
          <input v-model="form.privacy" type="checkbox" />
          {{ t("Accettare") }}
        </label>
        <div v-if="messaggi.length" class="spa-avviso">
          <div v-for="m in messaggi" :key="m">{{ t(m) }}</div>
        </div>
        <div class="spa-btn" :class="{ disabilitato: invio }" @click="prenota">
          <fa v-if="invio" :icon="['fas', 'spinner']" spin />
          {{ t("SPA_Prenota") }}
          <fa :icon="['fas', 'chevron-right']" />
        </div>
        <div class="spa-sub spa-centro">{{ t("Campiobbligatori") }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import apiService from "../services/api";
import paginaService from "../services/pagina";
import CybDatePicker from "../components/cybdatepicker.vue";

/** Lingua del Booking -> lingua del browser, per le date e i prezzi. */
const LOCALI = { ita: "it-IT", ing: "en-GB", eng: "en-GB", ted: "de-DE", fra: "fr-FR", spa: "es-ES", por: "pt-PT", jap: "ja-JP" };

/**
 * Prenotazione online di un trattamento della SPA dell'hotel.
 *
 * Si apre come il Booking: /spa?RPC_db=...&idhotel=...&lan=ita (o con gli stessi
 * dati in POST dal sito dell'hotel). Il cliente scegli il giorno, il trattamento
 * dal catalogo e uno degli orari liberi, poi lascia i suoi dati; cabina e
 * operatore li assegna il gestionale.
 *
 * E' la gemella della pagina dei tavoli (ristorante.vue): stessa impaginazione e
 * stesso giro di chiamate, con il catalogo al posto dei pasti.
 */
export default {
  components: {
    CybDatePicker
  },
  data() {
    return {
      pronta: false,
      errore: "",
      testi: {},
      catalogo: [],
      operatori: [],
      oggi: "",
      ultimo: "",
      nota: "",
      telefono: "",
      privacy: "",
      data: "",
      // La stessa data scritta all'italiana: e' quella che si vede e si digita.
      dataTesto: "",
      idcategoria: 0,
      idoperatore: 0,
      chiuso: false,
      caricamento: false,
      // orari liberi per trattamento: id => [HH:MM]
      disponibili: {},
      scelta: { id: 0, nome: "", durata: 0, policy: "", orario: "" },
      form: { nome: "", telefono: "", email: "", note: "", privacy: false, sito: "" },
      errori: {},
      messaggi: [],
      invio: false,
      fatta: null,
      emailInviata: false
    };
  },
  computed: {
    /** Le categorie del catalogo, nell'ordine in cui le manda il gestionale. */
    categorie() {
      return this.catalogo;
    },
    /** Quelle da mostrare: tutte, o la sola scelta nel filtro. */
    categorieMostrate() {
      return this.idcategoria ? this.catalogo.filter((c) => c.id === this.idcategoria) : this.catalogo;
    },
    /** Il calendario spegne i giorni fuori dalla finestra prenotabile. */
    limitiData() {
      const limiti = {};
      if (this.oggi) {
        limiti.to = this.giorno(this.oggi);
      }
      if (this.ultimo) {
        const dopo = this.giorno(this.ultimo);
        dopo.setDate(dopo.getDate() + 1);
        limiti.from = dopo;
      }
      return limiti;
    }
  },
  watch: {
    // Qualunque strada cambi il giorno, la casella mostra la data italiana.
    data(sql) {
      this.dataTesto = this.dataITA(sql);
    },
    // Lingua cambiata dalla barra in alto: testi, catalogo e privacy nella nuova lingua.
    "$store.lang"(nuova, vecchia) {
      if (nuova && vecchia && nuova.toLowerCase() !== vecchia.toLowerCase()) {
        this.caricaConfigurazione();
      }
    }
  },
  mounted() {
    // Parametri come nel Booking: in POST dal sito dell'hotel o nell'indirizzo.
    const post = typeof this.$postData !== "undefined" && this.$postData && this.$postData.RPC_db ? this.$postData : null;
    const q = post || this.$route.query;
    this.$store.db = q.RPC_db || "";
    this.$store.idhotel = q.idhotel || "";
    this.$store.lang = (q.lan || "ita").toUpperCase();
    paginaService.neutra(this);
    if (!this.$store.db || !this.$store.idhotel) {
      this.errore = "ERR_RPC";
      return;
    }
    // Lingue della barra in alto.
    this.$root.$emit("lang:request", this.$store.lang);
    this.caricaConfigurazione();
  },
  methods: {
    t(chiave) {
      return this.testi[chiave] || chiave;
    },
    iniziale(testo) {
      return testo ? testo.charAt(0).toUpperCase() + testo.slice(1) : "";
    },
    lingua() {
      return String(this.$store.lang || "ita").toLowerCase();
    },
    /** Indirizzo di un'immagine del backend (logo, sfondo, fotografie). */
    url(percorso) {
      const base = String(this.$config.server_url || "").replace(/\/rest\/?$/, "");
      return percorso ? base + "/" + percorso : "";
    },
    prezzo(valore) {
      return new Intl.NumberFormat(LOCALI[this.lingua()] || "it-IT", { style: "currency", currency: "EUR" }).format(valore);
    },
    orari(id) {
      return this.disponibili[id] || [];
    },
    caricaConfigurazione() {
      apiService
        .get("BE_spa/" + this.$store.db + "/" + this.$store.idhotel + "/" + this.lingua())
        .then((resp) => {
          this.testi = resp.testi || {};
          paginaService.applica(this, resp.grafica);
          this.catalogo = resp.catalogo || [];
          this.operatori = resp.operatori || [];
          this.oggi = resp.oggi;
          this.ultimo = resp.ultimo;
          this.nota = resp.nota || "";
          this.telefono = String(resp.telefono || "").trim();
          this.privacy = resp.privacy || "";
          if (!this.data) {
            this.data = this.oggi;
          }
          this.pronta = true;
          this.caricaDisponibilita();
        })
        .catch((resp) => {
          this.testi = (resp && resp.testi) || this.testi;
          this.errore = (resp && resp.errori && resp.errori[0]) || "ERR_GENERIC";
        });
    },
    caricaDisponibilita() {
      this.scelta = { id: 0, nome: "", durata: 0, policy: "", orario: "" };
      if (!this.data) {
        return;
      }
      this.caricamento = true;
      apiService
        .get("BE_spa/disponibilita/" + this.$store.db + "/" + this.$store.idhotel + "?data=" + this.data + "&idoperatore=" + this.idoperatore)
        .then((resp) => {
          this.caricamento = false;
          this.chiuso = !!resp.chiuso;
          const orari = {};
          (resp.trattamenti || []).forEach((x) => {
            orari[x.id] = x.orari || [];
          });
          this.disponibili = orari;
        })
        .catch(() => (this.caricamento = false));
    },
    scegli(tr, orario) {
      this.scelta = { id: tr.id, nome: tr.nome, durata: tr.durata, policy: tr.policy || "", orario };
      this.$nextTick(() => this.$refs.dati && this.$refs.dati.scrollIntoView({ behavior: "smooth", block: "start" }));
    },
    /** Data SQL -> oggetto Date (mezzanotte locale). */
    giorno(sql) {
      const [a, m, g] = String(sql).split("-").map(Number);
      return new Date(a, m - 1, g);
    },
    /** Data SQL -> gg/mm/aaaa. */
    dataITA(sql) {
      const p = String(sql || "").split("-");
      return p.length === 3 ? p[2] + "/" + p[1] + "/" + p[0] : "";
    },
    /** gg/mm/aaaa -> data SQL, vuoto se non e' un giorno vero. */
    dataSQL(testo) {
      const p = String(testo || "").match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (!p) {
        return "";
      }
      const g = Number(p[1]);
      const m = Number(p[2]);
      const a = Number(p[3]);
      const d = new Date(a, m - 1, g);
      if (d.getDate() !== g || d.getMonth() !== m - 1 || d.getFullYear() !== a) {
        return "";
      }
      return a + "-" + String(m).padStart(2, "0") + "-" + String(g).padStart(2, "0");
    },
    /** Mentre si scrive: solo cifre, con le barre al posto giusto. */
    mascheraData(e) {
      const cifre = String(e.target.value).replace(/\D/g, "").slice(0, 8);
      let testo = cifre.slice(0, 2);
      if (cifre.length > 2) {
        testo += "/" + cifre.slice(2, 4);
      }
      if (cifre.length > 4) {
        testo += "/" + cifre.slice(4, 8);
      }
      this.dataTesto = testo;
      // La casella non e' legata con v-model: il valore filtrato si riscrive a mano.
      e.target.value = testo;
    },
    /**
     * Data scritta a mano o scelta dal calendario: si accetta solo se e' un
     * giorno vero dentro la finestra prenotabile, altrimenti torna quella di
     * prima. Senza argomento vale quello che c'e' scritto nella casella.
     *
     * @param {string} [valore] gg/mm/aaaa
     */
    confermaData(valore) {
      const sql = this.dataSQL(valore === undefined ? this.dataTesto : valore);
      if (!sql || sql < this.oggi || (this.ultimo && sql > this.ultimo)) {
        this.dataTesto = this.dataITA(this.data);
        return;
      }
      this.dataTesto = this.dataITA(sql);
      if (sql !== this.data) {
        this.data = sql;
        this.caricaDisponibilita();
      }
    },
    dataLunga(sql) {
      if (!sql) {
        return "";
      }
      const [a, m, g] = sql.split("-").map(Number);
      return new Date(a, m - 1, g).toLocaleDateString(LOCALI[this.lingua()] || "it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
    },
    prenota() {
      if (this.invio) {
        return;
      }
      this.invio = true;
      this.errori = {};
      this.messaggi = [];
      apiService
        .post("BE_spa/prenota/" + this.$store.db + "/" + this.$store.idhotel + "/" + this.lingua(), {
          ...this.form,
          data: this.data,
          idtrattamento: this.scelta.id,
          orario: this.scelta.orario,
          idoperatore: this.idoperatore
        })
        .then((resp) => {
          this.invio = false;
          this.fatta = resp.prenotazione;
          this.emailInviata = !!resp.email;
          window.scrollTo(0, 0);
        })
        .catch((resp) => {
          this.invio = false;
          this.errori = (resp && resp.errors) || {};
          this.messaggi = (resp && resp.errori) || ["ERR_GENERIC"];
          // L'orario e' stato preso nel frattempo, oppure la persona scelta non
          // svolge il trattamento: in entrambi i casi si rilegge il libero.
          if (this.messaggi.includes("SPA_ErrOccupato") || this.messaggi.includes("SPA_ErrOrario") || this.messaggi.includes("SPA_ErrOperatore")) {
            const scelta = this.scelta;
            this.caricaDisponibilita();
            this.scelta = scelta;
          }
        });
    },
    ricomincia() {
      this.fatta = null;
      this.form = { nome: this.form.nome, telefono: this.form.telefono, email: this.form.email, note: "", privacy: false, sito: "" };
      this.caricaDisponibilita();
    }
  }
};
</script>

<style lang="scss">
@import "../css/variables.scss";

// Sotto la barra dell'hotel, come le altre pagine del Booking (.home, .rist).
.spa {
  position: absolute;
  top: 7em;
  left: 0;
  right: 0;
  max-width: 820px;
  margin: 20px auto 40px;
  padding: 0 12px;
  text-align: left;
}
@media (max-width: 576px) {
  .spa {
    top: 11em;
  }
}
.spa-card {
  background: rgba(255, 255, 255, 0.96);
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 16px;
}
.spa-titolo {
  font-size: 1.3em;
  font-weight: 600;
  color: var(--base-color);
  margin: 0 0 12px;
}
.spa-categoria {
  font-size: 1.1em;
  font-weight: 600;
  color: var(--base-color);
  margin: 0 0 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.spa-nota {
  background: #f6f7f9;
  border-left: 4px solid var(--base-color);
  padding: 8px 12px;
  margin-bottom: 12px;
  font-size: 0.9em;
}
.spa-riga {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  align-items: flex-end;
}
.spa-campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
  flex: 1 1 180px;
  margin-bottom: 8px;
  span {
    font-size: 0.8em;
    font-weight: 600;
    color: $muted;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  input,
  select,
  textarea {
    border: 1px solid #d5d9e0;
    border-radius: 6px;
    padding: 8px 10px;
    font: inherit;
    color: $text;
    background: #fff;
  }
  input[type="date"] {
    text-align: center;
    &::-webkit-date-and-time-value {
      text-align: center;
    }
  }
  // Data all'italiana: casella scrivibile e icona del calendario accanto.
  &.spa-campo-data .spa-data {
    position: relative;
    display: flex;
    align-items: center;
    // Lo span non e' un'etichetta: niente maiuscolo ne' corpo ridotto.
    font-size: 1em;
    font-weight: normal;
    text-transform: none;
    letter-spacing: normal;
    input[type="text"] {
      flex: 1 1 auto;
      // Spazio per l'icona, che sta sopra il bordo destro della casella.
      padding-right: 30px;
      text-align: center;
    }
    // Del datepicker serve solo l'icona: la sua casella non si usa.
    .cyb-date-input input {
      display: none;
    }
    .vdp-datepicker {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
    }
    .date-icon {
      margin: 0 !important;
      color: $muted;
      cursor: pointer;
    }
  }
  &.largo {
    flex-basis: 100%;
  }
  &.spa-err input,
  &.spa-err textarea {
    border-color: $negative;
  }
}
// Scheda di un trattamento: la fotografia a sinistra, il testo e gli orari a
// destra. Sotto i 576px la fotografia passa sopra, a tutta larghezza.
.spa-tratt {
  display: flex;
  gap: 14px;
  padding: 14px 0;
  border-top: 1px solid #eef0f3;
  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }
  &.scelto {
    background: var(--base-light);
    border-radius: 8px;
    padding-left: 10px;
    padding-right: 10px;
  }
}
.spa-foto {
  width: 150px;
  height: 110px;
  object-fit: cover;
  border-radius: 8px;
  flex: 0 0 auto;
}
/**
 * Il posto della fotografia che manca: una sfumatura sfocata nei colori della
 * struttura, con il simbolo del centro sopra. Lo sfocato sta in ::before,
 * altrimenti sfocherebbe anche il simbolo.
 */
.spa-foto-finta {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8edf1;
}
.spa-foto-finta::before {
  content: "";
  position: absolute;
  top: -20%;
  right: -20%;
  bottom: -20%;
  left: -20%;
  background: radial-gradient(circle at 28% 32%, var(--base-light, #d7e0e6), transparent 60%),
    radial-gradient(circle at 72% 72%, var(--base-color, #9bb0bd), transparent 55%),
    linear-gradient(135deg, #e3eaef 0%, #c6d2da 100%);
  filter: blur(14px);
}
.spa-foto-finta svg {
  position: relative;
  font-size: 2.2em;
  color: #fff;
  opacity: 0.75;
}
.spa-tratt-testo {
  flex: 1 1 auto;
  min-width: 0;
}
.spa-tratt-nome {
  font-weight: 600;
  font-size: 1.05em;
}
.spa-tratt-dati {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin: 4px 0;
  font-size: 0.9em;
  color: #4b5563;
  svg {
    color: var(--base-color);
  }
}
.spa-tratt-desc {
  font-size: 0.9em;
  margin-bottom: 8px;
  white-space: pre-line;
}
.spa-orari {
  margin-top: 6px;
}
.spa-orari-elenco {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}
.spa-orario {
  border: 2px solid var(--base-color);
  color: var(--base-color);
  border-radius: 20px;
  padding: 5px 14px;
  cursor: pointer;
  user-select: none;
  font-weight: 600;
  &:hover {
    background: var(--base-light);
  }
  &.scelto {
    background: var(--base-color);
    color: #fff;
  }
}
@media (max-width: 576px) {
  .spa-tratt {
    flex-direction: column;
  }
  .spa-foto {
    width: 100%;
    height: 150px;
  }
}
.spa-sub {
  font-size: 0.85em;
  color: #6b7280;
}
.spa-centro {
  text-align: center;
  margin-top: 6px;
}
.spa-attesa {
  padding: 16px;
  text-align: center;
  color: var(--base-color);
}
.spa-scelta {
  font-weight: 600;
  margin-bottom: 12px;
}
.spa-avviso {
  color: $negative;
  font-weight: 600;
  margin: 10px 0;
}
.spa-policy {
  margin-top: 6px;
}
.spa-policy-testo {
  max-height: 120px;
  overflow: auto;
  font-size: 0.75em;
  background: #f6f7f9;
  padding: 8px;
  border-radius: 6px;
  white-space: pre-wrap;
}
.spa-accetto {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 10px 0;
  &.spa-err {
    color: $negative;
    font-weight: 600;
  }
}
.spa-civetta {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  opacity: 0;
}
.spa-btn {
  background: var(--base-color);
  color: #fff;
  text-align: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  user-select: none;
  margin-top: 8px;
  &.disabilitato {
    opacity: 0.6;
    pointer-events: none;
  }
}
.spa-messaggio {
  text-align: center;
  h2 {
    font-size: 1.3em;
    margin: 12px 0;
  }
}
.spa-icona-grande {
  font-size: 2.6em;
  color: var(--base-color);
}
.spa-riepilogo {
  display: inline-block;
  text-align: left;
  margin: 8px 0 12px;
  div {
    display: flex;
    gap: 16px;
    justify-content: space-between;
    padding: 3px 0;
    border-bottom: 1px solid #eef0f3;
  }
  span {
    color: #6b7280;
  }
  b::first-letter {
    text-transform: uppercase;
  }
}
</style>
